// SiteContext.js
import React, { createContext, useContext, useEffect, useState } from "react";
import { gql, GraphQLClient } from "graphql-request";

const SiteContext = createContext();

export const SiteProvider = ({ children }) => {
  const [siteContent, setsiteContent] = useState(null);
  const clientUrl = process.env.REACT_APP_HYGRAPH_CONTENT_API
  const siteId = process.env.REACT_APP_HYGRAPH_SITE_ID

  useEffect(() => {
    fetchSite();
  }, []);

  async function fetchSite() {
    const client = new GraphQLClient(clientUrl);

    const query = gql`
      query GetSite($id: ID!) {
        site(where: { id: $id }) {
          id
          title
          logo {
            url
          }
          page {
            title
            headContent
            bodyContent 
            slug
            image {
              url
            }
          }
          production {
            id
            organizersOrAuthorsOrEvent
            cover{
              url
            }
            description
            nameFile
            name
            published
            type
          }
          video {
            url
            title
          }
          social {
            id
            name
            url
            icon {
              url
            }
          }
          information {
            id
            content {
              markdown
            }
            image {
              url
            }
            galleryInformation
            date
            important
            title
            subtitle
          }
          image {
            nameFile
            title
          }
        }
      }
    `;

    const data = await client.request(query, { id: siteId });
    setsiteContent(data.site);
  }

  return (
    <SiteContext.Provider value={{ siteContent }}>
      {children}
    </SiteContext.Provider>
  );
};

export default function useSiteContent() {
  return useContext(SiteContext);
}